import type { TAuthStatus } from '@cascade/core/auth';
import type { TPendingTitleKey } from './SessionPending.types.ts';

export const getPendingTitleKey = (status: TAuthStatus): TPendingTitleKey => {
  if (status === 'signing-in') {
    return 'pending.signIn';
  }

  if (status === 'signing-out') {
    return 'pending.signOut';
  }

  return 'pending.session';
};
